/* SEYUN Sea Moss PDP: offer selector (pack = single variant x quantity 1 / 2 / 3), gift line, ATC price, daily timer (midnight New York),
   page-only announcement bar, carousels, FAQ accordion, mobile logo rotation, ingredients expand. Isolated: only acts on pages that render ssm- blocks. */
(() => {
  if (window.__seyunSm) return;
  window.__seyunSm = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const pad = n => String(n).padStart(2, '0');

  /* seconds left until the next midnight in the market time zone (restarts every day) */
  function secondsToMidnight(tz) {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
    const g = t => Number((parts.find(p => p.type === t) || {}).value) || 0;
    const sec = (g('hour') % 24) * 3600 + g('minute') * 60 + g('second');
    return 86400 - sec;
  }
  const TZ = () => (($('[data-ssm-offer]') || {}).dataset || {}).tz || 'America/New_York';
  const clock = s => pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);

  function selected(offer) { return $('input[type=radio]:checked', offer) || $('input[type=radio]', offer); }
  function apply(offer) {
    const r = selected(offer);
    if (!r) return;
    const idx = Number(r.dataset.idx) || 1;
    $$('.ssm-gift', offer).forEach(g => g.classList.toggle('is-locked', idx < (Number(g.dataset.unlock) || 1)));
    $$('[data-ssm-id]').forEach(i => { i.value = r.value; });
    $$('[data-ssm-qty]').forEach(i => { i.value = r.dataset.qty || 1; });
    $$('[data-ssm-atc-price]').forEach(p => { p.textContent = r.dataset.price || ''; });
  }
  function timers() {
    const els = $$('[data-ssm-clock]');
    if (!els.length) return;
    const tick = () => { const t = clock(secondsToMidnight(TZ())); els.forEach(e => { if (e.textContent !== t) e.textContent = t; }); };
    tick(); setInterval(tick, 1000);
  }
  /* Page-only rewrite of the native announcement bar (same text and countdown as the reference bar). Other pages keep the native bar. */
  function announce() {
    const holder = $('[data-ssm-announce]');
    if (!holder) return;
    const nodes = $$('.sy-announcement-desktop,.sy-announcement-mobile');
    if (!nodes.length) return;
    const title = holder.dataset.title || '', sub = holder.dataset.sub || '', L = (holder.dataset.units || 'Hours|Min|Sec').split('|');
    const render = () => {
      const s = secondsToMidnight(TZ());
      const html = '<span class="ssm-ann"><span class="ssm-ann-t"><b>' + title + '</b><span>' + sub + '</span></span><span class="ssm-ann-c">' +
        '<em><b>' + pad(Math.floor(s / 3600)) + '</b><i>' + L[0] + '</i></em><u>:</u><em><b>' + pad(Math.floor(s / 60) % 60) + '</b><i>' + L[1] + '</i></em><u>:</u><em><b>' + pad(s % 60) + '</b><i>' + L[2] + '</i></em></span></span>';
      nodes.forEach(n => { if (n.dataset.ssmHtml !== html) { n.innerHTML = html; n.dataset.ssmHtml = html; } });
    };
    render(); setInterval(render, 1000);
  }
  function initOffers() {
    $$('[data-ssm-offer]').forEach(offer => {
      if (offer.dataset.ready) return;
      offer.dataset.ready = '1';
      offer.addEventListener('change', () => apply(offer));
      apply(offer);
    });
    if (!window.__ssmTimers) { window.__ssmTimers = true; timers(); announce(); }
  }

  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
    let j = {};
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
    return j;
  }
  async function openDrawer() {
    await new Promise(r => setTimeout(r, 450));
    const d0 = $('#moonbundle-cart-drawer');
    if (d0 && d0.classList.contains('open')) return;
    const trigger = $('a[href$="/cart"][id*="cart-icon"], #cart-icon-bubble, .header__icon--cart, [data-moonbundle-cart-trigger]');
    if (trigger) { trigger.click(); await new Promise(r => setTimeout(r, 500)); }
    const d = $('#moonbundle-cart-drawer');
    if (!(d && d.classList.contains('open')) && !$('cart-drawer.active, cart-drawer[open]')) window.location.assign(root + 'cart');
  }
  async function addToCart(form) {
    const offer = $('[data-ssm-offer]');
    const r = offer && selected(offer);
    const id = Number($('[data-ssm-id]', form).value);
    const qty = Math.max(1, Number(r && r.dataset.qty) || 1);
    const idx = Number(r && r.dataset.idx) || 1;
    const tag = (offer && offer.dataset.giftTag) || 'seamoss-offer';
    const items = [];
    const g = String((offer && offer.dataset.gift) || '').split(':');
    if (g[0] && idx >= (Number(g[1]) || 1)) items.push({ id: Number(g[0]), quantity: 1, properties: { _free_gift: tag } });
    items.push({ id, quantity: qty }); // added last: Shopify lists the jars first, the gift below
    const btn = $('[data-ssm-atc]', form), err = $('[data-ssm-error]');
    if (err) err.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    window.__ssmBusy = true;
    try {
      await post('cart/add.js', { items });
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-sm' } }));
      await openDrawer();
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; }
    } finally { window.__ssmBusy = false; btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('.ssm-form');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  /* carousel: one page = what is visible; dots = pages */
  function pages(track) { const c = track.firstElementChild; if (!c) return 1; const step = c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); const vis = Math.max(1, Math.round(track.clientWidth / step)); return Math.max(1, track.children.length - vis + 1); }
  function carouselInit() {
    $$('[data-ssm-carousel]').forEach(car => {
      const track = $('[data-ssm-track]', car), dots = $('[data-ssm-dots]', car), prev = $('[data-ssm-prev]', car), next = $('[data-ssm-next]', car);
      if (!track || car.dataset.ready) return;
      car.dataset.ready = '1';
      const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 300; };
      const idx = () => Math.round(track.scrollLeft / step());
      const build = () => { const n = pages(track); dots.innerHTML = ''; for (let i = 0; i < n; i++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to ' + (i + 1)); b.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' })); dots.appendChild(b); } mark(); };
      const mark = () => { const i = Math.min(idx(), Math.max(0, dots.children.length - 1)); Array.from(dots.children).forEach((d, k) => d.classList.toggle('is-active', k === i)); if (prev) prev.disabled = i <= 0; if (next) next.disabled = i >= dots.children.length - 1; };
      track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      build(); window.addEventListener('resize', build);
    });
  }
  /* FAQ: one open at a time */
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d.matches && d.matches('.ssm-faq-q')) || !d.open) return;
    $$('.ssm-faq-q[open]', d.parentNode).forEach(o => { if (o !== d) o.open = false; });
  }, true);
  /* mobile: one press logo at a time */
  function rotate() {
    $$('[data-ssm-rotate]').forEach(w => {
      if (w.dataset.ready) return; w.dataset.ready = '1';
      const logos = $$('.ssm-seen-logo', w); if (logos.length < 2) return;
      let i = 0; setInterval(() => { logos[i].classList.remove('is-active'); i = (i + 1) % logos.length; logos[i].classList.add('is-active'); }, 2500);
    });
  }
  document.addEventListener('click', e => {
    const m = e.target.closest('[data-ssm-ing-more]');
    if (m) { const g = $('[data-ssm-ing-grid]'); if (g) g.classList.remove('is-collapsed'); m.classList.add('is-hidden'); }
  });
  function init() { initOffers(); carouselInit(); rotate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
